export type LearningSystemExplainerVisual =
	| 'system'
	| 'program'
	| 'itinerary'
	| 'route'
	| 'topic'
	| 'resource'

export interface LearningSystemExplainerItem {
	step: string
	title: string
	description: string
	eyebrow?: string
	detail?: string
	visual?: LearningSystemExplainerVisual
}

export interface LearningSystemExplainerProps {
	eyebrow?: string
	title?: string
	subtitle?: string
	background?: 'default' | 'muted' | 'primary-light'
	items?: LearningSystemExplainerItem[]
}

const defaultVisuals: LearningSystemExplainerVisual[] = [
	'system',
	'program',
	'route',
	'topic',
	'resource',
]

export function resolveLearningSystemVisual(
	visual: LearningSystemExplainerVisual | undefined,
	index: number,
): LearningSystemExplainerVisual {
	return visual ?? defaultVisuals[index] ?? 'system'
}
